"use strict";
exports.__esModule = true;
var TextAnnotator_1 = require("./TextAnnotator");
exports.TextAnnotator = TextAnnotator_1["default"];
var TokenAnnotator_1 = require("./TokenAnnotator");
exports.TokenAnnotator = TokenAnnotator_1["default"];
//# sourceMappingURL=index.js.map